import * as React from 'react';
import {defaults, get, isEmpty} from 'lodash';
import {
  FormikStageConfig,
  IAccountDetails,
  IStage,
  IStageConfigProps,
  IArtifact,
  IExpectedArtifact,
  ExpectedArtifactService,
  SETTINGS,
} from '@spinnaker/core';
import {TerraformStageForm} from './TerraformStageForm';

export interface ITerraformStageConfigState {
  accounts: IAccountDetails[];
}

interface IArtifactIdPair {
  id: string;
  artifact: IArtifact;
  account: string;
}

export class TerraformStageConfig extends React.Component<IStageConfigProps, ITerraformStageConfigState> {
  private stage: IStage;

  public constructor(props: IStageConfigProps) {
    super(props);
    this.stage = props.stage;

    if (SETTINGS.feature['artifacts']) {
      this.migratePreRewrite();
    } else if (SETTINGS.feature['artifactsRewrite']) {
      this.migrateArtifacts(props.stage);
    }
  }

  // this makes the new UI backward compatible for pre-ui terraform users with
  // existing pipelines using the old artifact format
  // Note: this can be removed once all users have migrated their pipeline json to the new format
  private migrateArtifacts(stage: IStage) {
    const artifacts = get(this.stage, ['artifacts'], []);
    const backendArtifact = get(this.stage, ['backendArtifact'], {})

    if (!isEmpty(artifacts) && artifacts[0].reference) {
      artifacts.map((artifact, i) => {
        stage.artifacts[i] = this.makeRewriteArtifact(artifact);
      });
    }
    if (!isEmpty(backendArtifact) && backendArtifact.reference) {
      stage.backendArtifact = this.makeRewriteArtifact(backendArtifact);
    }
  }

  // migratePreRewrite converts artifacts to the pre-rewrite form. This involves
  // adding them to the pipeline's expected artifacts list, assigning ids and
  // linking the two
  private migratePreRewrite = () => {
    const { stage } = this;
    const artifacts = get(stage, ['artifacts'], []);
    const backendArtifact = get(stage, ['backendArtifact'], {});

    artifacts.forEach((a, idx) => {
      if (isEmpty(a.reference)) {
        return;
      }

      const preRewriteArtifact = this.makePreRewriteArtifact(a);
      ExpectedArtifactService.addArtifactTo(preRewriteArtifact, this.props.pipeline)
      const replacementArtifact = { id: preRewriteArtifact.id, account: a.artifactAccount || '' };
      stage.artifacts[idx] = replacementArtifact;
    });

    if (get(backendArtifact, ['reference'], '') !== '') {
      const preRewriteArtifact = this.makePreRewriteArtifact(backendArtifact);
      ExpectedArtifactService.addArtifactTo(preRewriteArtifact, this.props.pipeline)
      const replacementArtifact = { id: preRewriteArtifact.id, account: backendArtifact.artifactAccount || '' };
      stage.backendArtifact = replacementArtifact;
    }
  };

  private makePreRewriteArtifact = (a: any): IExpectedArtifact => {
    const emptyArtifact = ExpectedArtifactService.createEmptyArtifact();
    defaults(emptyArtifact.matchArtifact, a);
    defaults(emptyArtifact.defaultArtifact, a);
    emptyArtifact.useDefaultArtifact = true;
    if (a.name) {
      emptyArtifact.displayName = a.name
    }
    return emptyArtifact;
  };

  private makeRewriteArtifact = (artifact: any): IArtifactIdPair => {
    const converted = {} as IArtifactIdPair;

    if (isEmpty(artifact.name)) {
      artifact.name = 'bleh';
    }

    converted.account = artifact.artifactAccount || '';
    converted.artifact = artifact;
    return converted;
  };

  public componentDidMount() {
    defaults(this.stage, {
      artifacts: [],
      overrides: {},
    });
  }

  public render() {
    return (
      <FormikStageConfig
        {...this.props}
        stage={this.stage}
        onChange={this.props.updateStage}
        render={props => <TerraformStageForm {...props} />}
      />
    );
  }
}
